import { QuestionCategory, QuestionType } from "@/api/user/useGetMyQuestions";
import { SignupQuestionnaire } from "@/components/Signup/SignupQuestionnaire";
import { QuestionnaireFlowQuestion } from "@/types/question.types";

const signupQuestions: QuestionnaireFlowQuestion[] = [
  {
    slug: "identityVerification",
    category: QuestionCategory.SIGNUP,
    type: QuestionType.TEXT,
    title: "본인인증을 진행해주세요",
    subtitle: "휴대폰 본인인증이 필요합니다",
    extra: {},
  },
  {
    slug: "nickname",
    category: QuestionCategory.SIGNUP,
    type: QuestionType.TEXT,
    title: "오프 이벤트에서 사용할 닉네임을 정해주세요",
    extra: {},
  },
  {
    slug: "email",
    category: QuestionCategory.SIGNUP,
    type: QuestionType.TEXT,
    title: "이메일이 어떻게 되시나요?",
    extra: {},
  },
  {
    slug: "password",
    category: QuestionCategory.SIGNUP,
    type: QuestionType.TEXT,
    title: "비밀번호를 입력해주세요",
    subtitle: "최소 8자 이상 입력해주세요",
    extra: {},
  },
];

export function EmailSignupPage() {
  return <SignupQuestionnaire questions={signupQuestions} />;
}
